module.exports = __webpack_public_path__ + "img/logo-mini.053dd8cf.png";